import routerOptions0 from "/usr/src/app/node_modules/.pnpm/nuxt@4.6.3_67a7375ff746f984e53749730d851ddb/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto",
  sensitive: false
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}